import React, { useEffect, useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import logo from '../Images/logo.png'
import whitelogo from '../Images/white-logo.png'
//import heroImg from '../Images/Hero1.webp';
import { aboutLinks, bentoniteDropdown, industrialMinerals } from "../Data";
import heroVdo from '../Video/hero-vdo.mp4';
import heroMobileVdo from '../Video/hero-mobile-vdo.mp4'
import { FaYoutube, FaFacebookF, FaLinkedinIn, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const Hero = () => {
  const [scrolled, setScrolled] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const navigate = useNavigate();

 useEffect(() => {
  if (menuOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
}, [menuOpen]);

useEffect(() => {
  const handleScroll = () => {
    if (!isMobile) {
      setScrolled(window.scrollY > 10);
    }
  };

  window.addEventListener("scroll", handleScroll, { passive: true });
  return () => window.removeEventListener("scroll", handleScroll);
}, [isMobile]);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 992);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  // 🔹 Premium Animations
  const navContainer = {
    hidden: { opacity: 0, y: -30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
        staggerChildren: 0.08
      }
    }
  };

  const navItem = {
    hidden: { opacity: 0, y: -10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  const heroText = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeOut" }
    }
  };

  return (
    <>
      {/* NAVBAR */}
      <motion.header
        variants={navContainer}
        initial="hidden"
        animate="visible"
        className={`navbar ${scrolled ? "scrolled" : ""} ${
          hovered ? "hovered" : ""
        }`}
        onMouseEnter={() => !isMobile && setHovered(true)}
onMouseLeave={() => !isMobile && setHovered(false)}
      >
        {/* LOGO */}
        <motion.div
          className="logo-row"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
        <img   src={isMobile ? logo : (scrolled || hovered ? logo : whitelogo)} alt="Iris Impulse India Pvt. Ltd. Logo" className="logo" />

  {/* HAMBURGER */}
  <div
    className={`hamburger ${menuOpen ? "active" : ""}`}
    onClick={() => setMenuOpen(!menuOpen)}
  >
    <span></span>
    <span></span>
    <span></span>
  </div>
        </motion.div>

        {/* NAV LINKS */}
        <nav className="nav-row">
          <ul>
         <a href="/"><motion.li variants={navItem}>HOME</motion.li></a>
            <span className="diamond"></span>

           <motion.li variants={navItem} className="dropdown">
                         <a href="/about-us"><span className="nav-item">
                           ABOUT US
                           <span className="chevron"></span>
                         </span></a>
           
                         <ul className="dropdown-menu">
                           {aboutLinks.map((item, index) => (
                            <Link to={item.url}><li key={index}>{item.title}</li></Link> 
                           ))}
                         </ul>
                       </motion.li>
            <span className="diamond"></span>

            {/* BENTONITE */}
            <motion.li variants={navItem} className="dropdown">
              <a href="/bentonite-minerals"><span className="nav-item">
                BENTONITE MINERALS
                <span className="chevron"></span>
              </span></a>

              <ul className="dropdown-menu">
                {bentoniteDropdown.map((item, index) => (
                <Link to={`/bentonite-minerals/${item.url}`}><li key={index}
                  >{item.title}</li></Link>  
                ))}
              </ul>
            </motion.li>

            <span className="diamond"></span>

            {/* INDUSTRIAL */}
            <motion.li variants={navItem} className="dropdown">
                <a href="/industrial-minerals"><span className="nav-item">
                INDUSTRIAL MINERALS
                <span className="chevron"></span>
              </span></a>
 <ul className="dropdown-menu">
                {industrialMinerals.map((item, index) => (
                  <Link to={`/industrial-minerals/${item.url}`}><li key={index}>{item.title}</li></Link> 
                ))}
              </ul>
            </motion.li>

            <span className="diamond"></span>

            <a href="/blogs"><motion.li variants={navItem}>BLOGS</motion.li></a>
            <span className="diamond"></span>

            <a href="/contact-us"><motion.li variants={navItem}>CONTACT US</motion.li></a>
          </ul>
        </nav>
      </motion.header>

      {/* SIDEBAR */}
<div className={`mobile-sidebar ${menuOpen ? "active" : ""}`}>
  
  {/* TOP LOGO */}
  <div className="sidebar-header">
    <img src={logo} alt="Iris Impulse India Pvt. Ltd. Logo" />
  </div>

  <ul>
    <a href="/"><li onClick={() => setMenuOpen(false)}>HOME</li></a>

    <li className="mobile-dropdown">
      <div className="mobile-dropdown-head">
        <span onClick={() => navigate("/about-us")}>
          ABOUT US
        </span>

        <span
          className={`chevron ${openDropdown === "about" ? "open" : ""}`}
          onClick={() =>
            setOpenDropdown(openDropdown === "about" ? null : "about")
          }
        ></span>
      </div>

      <div className={`mobile-submenu ${openDropdown === "about" ? "open" : ""}`}>
        {aboutLinks.map((item, index) => (
          <Link key={index} to={item.url}>
            <div>{item.title}</div>
          </Link>
        ))}
      </div>
    </li>

    {/* BENTONITE */}
    <li className="mobile-dropdown">
      <div className="mobile-dropdown-head">
        <span onClick={() => navigate("/bentonite-minerals")}>
          BENTONITE MINERALS
        </span>

        <span
          className={`chevron ${openDropdown === "bentonite" ? "open" : ""}`}
          onClick={() =>
            setOpenDropdown(openDropdown === "bentonite" ? null : "bentonite")
          }
        ></span>
      </div>

      <div className={`mobile-submenu ${openDropdown === "bentonite" ? "open" : ""}`}>
        {bentoniteDropdown.map((item, index) => (
          <Link key={index} to={`/bentonite-minerals/${item.url}`}>
            <div>{item.title}</div>
          </Link>
        ))}
      </div>
    </li>

    {/* INDUSTRIAL */}
    <li className="mobile-dropdown">
      <div className="mobile-dropdown-head">
        <span onClick={() => navigate("/industrial-minerals")}>
          INDUSTRIAL MINERALS
        </span>

        <span
          className={`chevron ${openDropdown === "industrial" ? "open" : ""}`}
          onClick={() =>
            setOpenDropdown(openDropdown === "industrial" ? null : "industrial")
          }
        ></span>
      </div>

      <div className={`mobile-submenu ${openDropdown === "industrial" ? "open" : ""}`}>
        {industrialMinerals.map((item, index) => (
          <Link key={index} to={`/industrial-minerals/${item.url}`}>
            <div>{item.title}</div>
          </Link>
        ))}
      </div>
    </li>

    <a href="/blogs">
      <li onClick={() => setMenuOpen(false)}>BLOGS</li>
    </a>

    <a href="/contact-us">
      <li onClick={() => setMenuOpen(false)}>CONTACT US</li>
    </a>
  </ul>

  {/* SIDEBAR FOOTER */}
  <div className="mobile-sidebar-footer">

    {/* SOCIAL ICONS */}
    <div className="sidebar-socials">

      <a
        href="https://www.youtube.com/@IrisImpulseIndia"
        target="_blank"
        rel="noreferrer"
      >
        <FaYoutube />
      </a>

      <a
        href="https://www.facebook.com/Irisimpulsebentonite"
        target="_blank"
        rel="noreferrer"
      >
        <FaFacebookF />
      </a>

      <a
        href="https://www.linkedin.com/company/iris-impulse-india-private-limited/"
        target="_blank"
        rel="noreferrer"
      >
        <FaLinkedinIn />
      </a>

    </div>

    {/* EMAIL */}
    <a
      href="mailto:rajan@irisimpulse.com"
      className="sidebar-contact"
    >
      <FaEnvelope />
      <span>rajan@irisimpulse.com</span>
    </a>

    {/* PHONE */}
    <a
      href="tel:+919638482211"
      className="sidebar-contact"
    >
      <FaPhoneAlt />
      <span>+91 96384 82211</span>
    </a>

  </div>

</div>

{/* OVERLAY */}
<div
  className={`sidebar-overlay ${menuOpen ? "active" : ""}`}
  onClick={() => setMenuOpen(false)}
/>

      {/* HERO SECTION */}
      <section className="hero">
        

      <video
  key={isMobile ? "mobile-hero" : "desktop-hero"}
  className="hero-video"
  autoPlay
  loop
  muted
  playsInline
  preload="metadata"
>
  <source
    src={isMobile ? heroMobileVdo : heroVdo}
    type="video/mp4"
  />
</video>
        <div className="hero-overlay">
          
          {/* HEADING */}
          <motion.h1
            variants={heroText}
            initial="hidden"
            animate="visible"
          >
            Global Leader in Bentonite Performance Minerals & Industrial Minerals Since 1991
          </motion.h1>

          {/* BUTTON */}
          {/*<motion.a
          href="/about-us"
            className="hero-btn"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
          >
            <span>LEARN MORE</span>
          </motion.a>*/}
        </div>
      </section>
    </>
  );
};

export default Hero;